<template>
    <div>
        <div v-if="status == 0">
            Mengambil data barang, mohon menunggu...
        </div>
        <div v-else-if="status == -1">
            Gagal mengambil data barang.
        </div>
        <div v-else-if="status == 1">
            <h3 class="mb-0">{{ data.type }} <span v-if="data.year != null">({{ data.year }})</span></h3>
            {{ data.kind }} - {{ data.brand }}

            <b-badge v-if="!data.is_valid_photo" variant="danger">Foto tidak lengkap</b-badge>
            <b-row class="mt-2">
                <b-col md="4">
                    <strong>No. Faktur</strong><br />
                    {{ data.no_faktur_pgi }}
                </b-col>
                <b-col md="4">
                    <strong>IMEI / SN</strong><br />
                    {{ data.imei_sn || "-" }}
                </b-col>
                <b-col md="4">
                    <strong>Grade</strong><br />
                    {{ data.grade }}
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col md="4">
                    <strong>Kelengkapan</strong><br />
                    {{ data.is_batangan ? "Batangan" : "Lengkap" }}
                </b-col>
                <b-col md="4">
                    <strong>Spek</strong><br />
                    {{ data.spec || "-" }}
                </b-col>
                <b-col md="4">
                    <strong>Harga Dasar</strong><br />
                    Rp. {{ $helper.formatThousand(data.price) }}
                </b-col>
            </b-row>
            <!--             <b-form-group label="Catatan Barang" class="mt-3">
                <b-input v-model="note" maxlength="50" />
            </b-form-group> -->
            <b-table bordered hover show-empty no-local-sorting :items="items" :fields="fields" responsive class="my-4"
                @sort-changed="onSortChanged">
                <template v-slot:empty>
                    Tidak ada adjustment.
                </template>
                <template v-slot:cell(category)="row">
                    <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                    <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                    <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                    <b-form-select v-model="row.item.category" :options="optCategory"
                        @change="onChangeRowCategory(row.index)" />
                    <b-badge v-if="!row.item.is_adjustments_photo" variant="danger">Foto tidak tersedia</b-badge>
                </template>
                <template v-slot:cell(name)="row">
                    <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                    <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                    <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                    <b-form-select v-model="row.item.adjustmentSelect" :options="row.item.optAdjustments" />
                </template>
                <template v-slot:cell(adjustment)="row">
                    <b-input-group prepend="Rp.">
                        <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                        <!-- <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)" disabled></b-form-input> -->
                        <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)"
                            :disabled="row.item.adjustmentPercent != null && row.item.adjustmentPercent != ''"></b-form-input>
                    </b-input-group>
                </template>
                <template v-slot:cell(adjustmentPercent)="row">
                    <b-input-group append="%">
                        <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                        <!-- <b-form-input v-model="row.item.adjustmentPercent" disabled></b-form-input> -->
                        <b-form-input v-model="row.item.adjustmentPercent"
                            :disabled="row.item.adjustment != null && row.item.adjustment != ''"></b-form-input>
                    </b-input-group>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="d-flex">
                        <b-button size="sm" variant="dark" v-b-tooltip.hover.top title="Gambar Kerusakan"
                            :disabled="isSubmitting" @click="prepareAdjImage(row.item)">
                            <i class="fa fa-fw fa-picture-o" />
                        </b-button>
                        <b-button size="sm" variant="danger" class="ml-2" v-b-tooltip.hover.top title="Hapus"
                            @click="deleteRow(row.index)">
                            <i class="fa fa-fw fa-times" />
                        </b-button>
                    </div>
                </template>
            </b-table>
            <b-row>
                <b-col md="6">
                    <!-- <b-button variant="dark" @click="addRow"> -->
                    <b-button variant="dark" @click="prepareAddAdjustment" :disabled="isSubmitting">
                        <i class="fa fa-plus mr-2" />Tambah Keterangan
                    </b-button>
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button variant="primary" @click="confirmAdd" :disabled="isSubmitting">
                        <i class="fa fa-check mr-2" />Lanjutkan
                    </b-button>
                </b-col>
            </b-row>
        </div>
        <b-modal id="m-confirm" title="Konfirmasi" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Konfirmasi {{ invoiceDetailId == null ? 'penambahan' : 'pengubahan' }} barang ini kedalam invoice.
            <b-row class="mt-4">
                <b-col md="6">
                    <strong>No. Faktur</strong><br />
                    {{ data.no_faktur_pgi }}
                </b-col>
                <b-col md="6">
                    <strong>Harga Dasar</strong><br />
                    Rp. {{ $helper.formatThousand(data.price) }}
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <strong>Barang</strong><br />
                    {{ data.type }} <span v-if="data.year != null">({{ data.year }})</span>
                </b-col>
                <b-col md="6">
                    <strong>Total Pot / Tambahan Harga</strong><br />
                    <p class="mb-0" v-if="!$helper.isBlank(totalAdjustmentPercent)">
                        {{ Number(totalAdjustmentPercent).toFixed(2)
            + "% (Rp. " + $helper.formatThousand(totalAdjustmentPercentValue) + ")" }}</p>
                    <p class="mb-0" v-if="!$helper.isBlank(totalAdjustment) || $helper.isBlank(totalAdjustmentPercent)">
                        Rp. {{
            $helper.formatThousand(totalAdjustment) }}</p>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <strong>IMEI / SN</strong><br />
                    {{ data.imei_sn }}
                </b-col>
                <b-col md="6">
                    <strong>Tambahan Harga Jual Online</strong><br />
                    Rp. {{ $helper.formatThousand(data.adjustment_price_segment) }}
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <strong>Catatan Barang</strong><br />
                    {{ note || "-- Tidak ada catatan --" }}
                </b-col>
                <b-col md="6">
                    <strong>Harga Akhir</strong><br />
                    <strong>Rp. {{ $helper.formatThousand(data.price + totalAdjustment + totalAdjustmentPercentValue +
            data.adjustment_price_segment) }}</strong>
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button v-if="invoiceDetailId == null" variant="primary" :disabled="isSubmitting"
                    @click="execAddItem">
                    {{ isSubmitting ? "Menambahkan..." : "Tambahkan" }}
                </b-button>
                <b-button v-else variant="primary" :disabled="isSubmitting" @click="execEditItem">
                    {{ isSubmitting ? "Mengubah..." : "Ubah" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-image" :title="'Edit Gambar Kerusakan Item ' + data.type + ' (' + activeAdjustment.name + ')'"
            size="xl" @close="onCloseModalImage" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row>
                <b-col cols="12" lg="8">
                    <div class="media-container">
                        <b-img-lazy v-if="mediaPreview.media == 'image'" class="media-preview"
                            :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                            blank-src="image-loading.gif" block alt="Image Preview"></b-img-lazy>
                        <video v-else-if="mediaPreview.media == 'video'" class="media-preview" controls
                            :key="mediaPreview.url">
                            <source v-if="mediaPreview.type == 'video/webm'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/ogg'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/mp4'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/3gpp'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <!-- <source v-else :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" :type="mediaPreview.type"> -->
                            Your browser does not support the video tag.
                        </video>
                        <b-img-lazy v-else class="media-preview" src="/img/img-preview.png" block
                            alt="No Image"></b-img-lazy>
                    </div>
                    <div class="media-scroll">
                        <div class="media-scroll-content" v-for="(media, index) in filterMediaList" :key="'ms-' + index"
                            @click="onClickImage(media.url)">
                            <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }"
                                :src="media.media == 'video' ? '/img/video-thumbnail.png' : media.status == 'upload' ? media.url : $BASE_FILE_PATH + media.url"
                                blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy>
                            <!-- <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }" src="https://sample-videos.com/img/Sample-png-image-5mb.png" blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy> -->
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="4" class="border-responsive">
                    <!-- <b-button block variant="success" :disabled="filterMediaList.length >= 10 || isSubmitting"
                        @click="onAddImage">
                        {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar / Video Baru" }}
                    </b-button> -->

                    <b-button block variant="warning" class="mb-2" @click="onRefreshImage()">
                        Refresh
                    </b-button>

                    <span v-show="!isUpload" id="uploadFile" class="my-2">
                        <b-button block variant="success">
                            {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar / Video Baru" }}
                        </b-button>
                    </span>

                    <div :key="uploadKey">
                        <div v-for="item in fileUploadResumable" :key="item.uniqueIdentifier">
                            <div v-if="item && item.status == 'uploading'">{{ item.fileName || "" }}
                                <uploading style="width:100%" :completedSteps="item.progress" />
                            </div>

                            <div v-if="item && item.status == 'retry'" class="text-center">
                                Sedang menghubungkan kembali, mohon menunggu...
                            </div>

                            <div v-if="item && item.status == 'error'" class="text-center">
                                Mengalami kesalahan, silahkan coba lagi.
                            </div>
                        </div>

                        <div v-if="finalizeBroken" class="text-center">Sedang proses finalisasi, mohon menunggu...</div>
                    </div>
                    <b-button block variant="primary" class="mt-2"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting"
                        @click="onOpenImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Tampilkan Item di Tab Baru" }}
                    </b-button>
                    <b-button block variant="danger"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting"
                        @click="onDeleteImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Hapus Item" }}
                    </b-button>
                    <div class="mt-3 media-disclaimer">
                        <small>*Jenis item gambar yang dapat diterima oleh sistem adalah format JPG, JPEG, dan
                            PNG.</small><br>
                        <small>*Jenis item video yang dapat diterima oleh sistem adalah format MP4, OGG, dan
                            WEBM.</small><br>
                        <small>*Maksimal ukuran total gambar / video untuk sekali upload sebesar 200MB.</small><br>
                        <small>*Minimal jumlah item gambar / video per inventori sebanyak 1 buah item.</small><br>
                        <small>*Maksimal jumlah item gambar / video per inventori sebanyak 10 buah item.</small>
                    </div>
                </b-col>
            </b-row>
            <!-- <div class="mt-4 text-right">
                <b-button variant="secondary" class="mr-2" :disabled="isSubmitting" @click="$bvModal.hide('m-image')">
                    Batal
                </b-button>
                <b-button variant="primary" :disabled="isSubmitting" @click="onSaveImage">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div> -->
            <input multiple style="opacity: 0; filter:alpha(opacity=0);" ref="fileupload" type="file"
                @change="onUploadImage" accept="image/png, image/jpeg, video/mp4, video/webm, video/ogg">
        </b-modal>
        <b-modal id="m-add-adjustment" title="Tambah Adjustment" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Jenis Barang">
                <b-form-select v-model="addAdj.kind" :options="addAdj.optKind" disabled />
            </b-form-group>
            <b-form-group label="Kategori Kerusakan">
                <b-form-select v-model="addAdj.category" :options="optCategory" @input="onChangeAdjCategory" />
            </b-form-group>
            <b-form-group label="Keterangan">
                <b-form-select v-model="addAdj.name" :options="addAdj.optAdjustments"
                    :disabled="$helper.isBlank(addAdj.category) || addAdj.optAdjustments.length <= 0" />
            </b-form-group>
            <b-form-group label="Adjustment Harga (Nominal)">
                <b-input-group prepend="Rp.">
                    <b-form-input v-model="addAdj.adjustment" @input="sanitize(addAdj)"
                        :disabled="$helper.isBlank(addAdj.name) || addAdj.adjustmentPercentage != ''" maxlength="50" />
                </b-input-group>
            </b-form-group>
            <b-form-group label="Adjustment Harga (Persentase)">
                <b-input-group append="%">
                    <b-form-input v-model="addAdj.adjustmentPercentage"
                        :disabled="$helper.isBlank(addAdj.name) || addAdj.adjustment != ''" maxlength="50" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmAddAdjustment">
                    {{ isSubmitting ? "Menambah..." : "Tambah" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import lodash from 'lodash'
import Resumable from 'resumablejs';
import Uploading from './Uploading.vue'

export default {
    props: {
        noFaktur: { type: String, required: true },
        invoiceId: { type: Number, required: true },
        invoiceDetailId: { type: Number, default: null }
    },
    components: {
        Uploading
    },
    data() {
        return {

            status: 0, // 0: loading, 1: success, -1: fail
            isSubmitting: false,

            data: {},
            totalAdjustment: 0,
            totalAdjustmentPercent: 0,
            totalAdjustmentPercentValue: 0,
            note: "",
            photo: null,

            fields: [
                { key: "category", label: "Kategori", sortable: false, thClass: 'adjust-column-min' },
                { key: "name", label: "Keterangan", sortable: false, thClass: 'adjust-column-min' },
                { key: "adjustment", label: "Potongan / Tambahan Harga (Nominal)", sortable: true },
                { key: "adjustmentPercent", label: "Potongan / Tambahan Harga (Persen)", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],

            sortBy: null,
            sortDesc: false,

            mediaPreview: {},

            mediaList: [],

            isImageChanged: false,

            invoiceAdjustments: [],

            optCategory: [],

            addAdj: {
                kind: null,
                optKind: [],
                category: null,
                name: null,
                optAdjustments: [],
                adjustment: "",
                adjustmentPercentage: ""
            },

            activeAdjustment: {},

            fileUploadResumable: [],
            resumable: false,
            uploadKey: 0,
            isUpload: false,

            activeAdjustmentRow : null,
            finalizeBroken: false,

        }
    },
    methods: {

        init() {

            this.status = 0

            this.getItems()

        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getItems() {
            let payload = {
                no_faktur_pgi: this.noFaktur,
                invoice_id: this.invoiceId
            }

            if (this.invoiceDetailId != null) {
                payload.invoice_detail_id = this.invoiceDetailId
            }

            if (!this.$helper.isBlank(this.sortBy)) {
                payload["sortBy"] = this.sortBy
                payload["sortDesc"] = this.sortDesc
            }
            this.$axios.post("invoice/get-item", payload).then(res => {

                let data = res.data.data
                this.data = data

                this.items = data.adjustments

                if (this.invoiceDetailId != null) {
                    this.note = data.note
                }

                this.$axios.get("category/selection?item_kind_id=" + data.kind_id).then(res => {
                    this.optCategory = res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    })
                    for (let i = 0; i < this.items.length; i++) {
                        this.items[i].category = this.items[i].category_id
                        this.items[i].optAdjustments = this.items[i].optAdjustments.map(item => {
                            return {
                                value: {
                                    adjustments_id: item.id,
                                    adjustments_name: item.name,
                                    adjustment: item.adjustment,
                                    adjustment_percentage: item.adjustment_percentage,
                                },
                                text: item.name
                            }
                        })
                        for (let j = 0; j < this.items[i].optAdjustments.length; j++) {
                            if (this.items[i].optAdjustments[j].value.adjustments_id == this.items[i].adjustments_id) {
                                this.items[i].adjustmentSelect = lodash.cloneDeep(this.items[i].optAdjustments[j].value)
                                break
                            }
                        }
                    }

                    // diubah sementara supaya adjustment harga bisa diinput manual dulu
                    // this.items.forEach(it => {
                    //     it.adjustmentSelect = {
                    //         adjustments_id: it.adjustments_id,
                    //         adjustments_name: it.adjustments_name,
                    //         adjustment: it.adjustment,
                    //         adjustment_percentage: it.adjustment_percentage
                    //     }
                    // })
                    this.items.forEach(it => this.sanitize(it))
                    this.items.forEach(it => {
                        it.adjustment = this.$helper.isBlank(it.adjustment_percentage) ? String(it.adjustment) : ""
                        it.adjustmentPercent = this.$helper.isBlank(it.adjustment_percentage) ? "" : String(it.adjustment_percentage)
                    })

                    this.status = 1

                })
                    .catch(error => {

                        this.$helper.parseError(this, error)
                        this.status = -1

                    })

            })
                .catch(error => {

                    this.$helper.parseError(this, error)
                    this.status = -1

                })
        },

        // addRow() {
        //     this.items.push({ name: "", adjustmentSelect: "", adjustment: "", adjustmentPercent: "" })
        // },

        deleteRow(index) {
            this.items.splice(index, 1)
        },

        confirmAdd() {

            let adjustment = 0
            let adjustmentPercent = 0

            for (var i = 0; i < this.items.length; i++) {

                let item = this.items[i]

                if (this.$helper.isBlank(item.adjustmentSelect) || (this.$helper.isBlank(item.adjustment) && this.$helper.isBlank(item.adjustmentPercent))) {
                    return this.$helper.toastError(this, "Terdapat data adjustment yang kosong, mohon dilengkapi!")
                }

                if (!this.$helper.isBlank(item.adjustment)) {
                    adjustment += this.$helper.toNumber(item.adjustment)
                }
                else {
                    adjustmentPercent += parseFloat(item.adjustmentPercent.replace(',', '.').replace(' ', ''))
                }

            }

            if (this.data.price + adjustment < 0) {
                return this.$helper.toastError(this, "Tidak dapat menambahkan barang - harga akhir setelah adjustment dibawah nol!")
            }

            this.totalAdjustment = adjustment
            this.totalAdjustmentPercent = adjustmentPercent
            this.totalAdjustmentPercentValue = this.data.price * this.totalAdjustmentPercent / 100
            this.$bvModal.show("m-confirm")

        },

        execAddItem() {

            let payload = {
                no_faktur_pgi: this.noFaktur,
                invoice_id: this.invoiceId,
                adjustments: this.items.map(it => {
                    if (this.$helper.isBlank(it.adjustmentPercent)) {
                        return {
                            id: it.adjustmentSelect.adjustments_id,
                            name: it.adjustmentSelect.adjustments_name,
                            adjustment: this.$helper.toNumber(it.adjustment),
                            adjustmentPercent: null
                        }
                    }
                    else {
                        return {
                            id: it.adjustmentSelect.adjustments_id,
                            name: it.adjustmentSelect.adjustments_name,
                            adjustment: parseInt(this.data.price * parseFloat(it.adjustmentPercent.replace(',', '.').replace(' ', '')) / 100),
                            adjustmentPercent: Number(parseFloat(it.adjustmentPercent.replace(',', '.').replace(' ', ''))).toFixed(2)
                        }
                    }
                })
            }

            if (!this.$helper.isBlank(this.note)) {
                payload.note = this.note
            }

            this.isSubmitting = true
            this.$axios.post("invoice/add-item", payload).then(res => {

                this.$bvModal.hide("m-confirm")
                this.$emit("item-added", "Barang berhasil ditambahkan!")

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        execEditItem() {

            let payload = {
                invoice_detail_id: this.invoiceDetailId,
                adjustments: this.items.map(it => {
                    if (this.$helper.isBlank(it.adjustmentPercent)) {
                        return {
                            id: it.adjustmentSelect.adjustments_id,
                            name: it.adjustmentSelect.adjustments_name,
                            adjustment: this.$helper.toNumber(it.adjustment),
                            adjustmentPercent: null
                        }
                    }
                    else {
                        return {
                            id: it.adjustmentSelect.adjustments_id,
                            name: it.adjustmentSelect.adjustments_name,
                            adjustment: parseInt(this.data.price * parseFloat(it.adjustmentPercent.replace(',', '.').replace(' ', '')) / 100),
                            adjustmentPercent: Number(parseFloat(it.adjustmentPercent.replace(',', '.').replace(' ', ''))).toFixed(2)
                        }
                    }
                })
            }

            if (!this.$helper.isBlank(this.note)) {
                payload.note = this.note
            }

            this.isSubmitting = true
            this.$axios.post("invoice/edit-item", payload).then(res => {

                this.$bvModal.hide("m-confirm")
                this.$emit("item-added", "Barang berhasil diubah!")

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        sanitize(item) {

            let cleaned = String(item.adjustment).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            item.adjustment = res

        },

        sanitizeString(str) {
            let cleaned = String(str).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            return res
        },

        // diubah sementara supaya adjustment harga bisa diinput manual dulu
        // onChangeAdjustmentSelect(item, index){
        //     this.items[index].adjustments_id = item.adjustments_id
        //     this.items[index].adjustments_name = item.adjustments_name
        //     this.items[index].adjustment = this.sanitizeString(item.adjustment)
        //     this.items[index].adjustmentPercent = item.adjustment_percentage
        // },

        prepareAddAdjustment() {
            this.addAdj.optKind = [
                { value: this.data.kind_id, text: this.data.kind }
            ]
            this.addAdj.kind = this.data.kind_id
            this.addAdj.category = null
            this.addAdj.optAdjustments = []
            this.addAdj.name = null
            this.addAdj.adjustment = ""
            this.addAdj.adjustmentPercentage = ""
            this.$bvModal.show("m-add-adjustment")
        },

        confirmAddAdjustment() {
            if (this.$helper.isBlank(this.addAdj.name)) {
                this.$helper.toastError(this, "Data Keterangan Adjustment Kerusakan tidak boleh kosong !")
                return
            }

            if (this.$helper.isBlank(this.addAdj.adjustment) && this.$helper.isBlank(this.addAdj.adjustmentPercentage)) {
                this.$helper.toastError(this, "Salah satu dari data Adjustment Nominal atau Persentase tidak boleh kosong !")
                return
            }

            let payload = new FormData()

            payload.append("inventory_id", this.data.id)
            payload.append("adjustment_id", this.addAdj.name)
            if (this.$helper.isBlank(this.addAdj.adjustmentPercentage)) {
                payload.append("adjustment", this.$helper.toNumber(this.addAdj.adjustment))
            }
            else {
                payload.append("adjustment", parseInt(this.data.price * parseFloat(this.addAdj.adjustmentPercentage.replace(',', '.').replace(' ', '')) / 100))
                payload.append("adjustment_percentage", Number(parseFloat(this.addAdj.adjustmentPercentage.replace(',', '.').replace(' ', ''))).toFixed(2))
            }

            let url = ""

            if (this.$helper.isBlank(this.invoiceDetailId)) {
                url = "inventory/add-invoice-adjustments"
            }
            else {
                url = "invoice/add-invoice-adjustment"
                payload.append("invoice_detail_id", this.invoiceDetailId)
            }
            this.isSubmitting = true
            this.$axios.post(url, payload).then(res => {

                let payload = {
                    no_faktur_pgi: this.noFaktur,
                    invoice_id: this.invoiceId
                }

                if (this.invoiceDetailId != null) {
                    payload.invoice_detail_id = this.invoiceDetailId
                }

                if (!this.$helper.isBlank(this.sortBy)) {
                    payload["sortBy"] = this.sortBy
                    payload["sortDesc"] = this.sortDesc
                }
                this.$axios.post("invoice/get-item", payload).then(res => {

                    let data = res.data.data
                    this.data = data

                    for (let i = 0; i < data.adjustments.length; i++) {
                        data.adjustments[i].category = data.adjustments[i].category_id
                        data.adjustments[i].optAdjustments = data.adjustments[i].optAdjustments.map(item => {
                            return {
                                value: {
                                    adjustments_id: item.id,
                                    adjustments_name: item.name,
                                    adjustment: item.adjustment,
                                    adjustment_percentage: item.adjustment_percentage,
                                },
                                text: item.name
                            }
                        })
                        for (let j = 0; j < data.adjustments[i].optAdjustments.length; j++) {
                            if (data.adjustments[i].optAdjustments[j].value.adjustments_id == data.adjustments[i].adjustments_id) {
                                data.adjustments[i].adjustmentSelect = lodash.cloneDeep(data.adjustments[i].optAdjustments[j].value)
                                break
                            }
                        }
                    }

                    this.items = data.adjustments

                    if (this.invoiceDetailId != null) {
                        this.note = data.note
                    }

                    this.items.forEach(it => this.sanitize(it))
                    this.items.forEach(it => {
                        it.adjustment = this.$helper.isBlank(it.adjustment_percentage) ? String(it.adjustment) : ""
                        it.adjustmentPercent = this.$helper.isBlank(it.adjustment_percentage) ? "" : String(it.adjustment_percentage)
                    })
                    this.$bvModal.hide("m-add-adjustment")
                    this.isSubmitting = false

                })

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })
        },
        onChangeRowCategory(index) {
            this.items[index].name = ""
            this.items[index].adjustmentSelect = null
            this.items[index].optAdjustments = []
            if (!this.$helper.isBlank(this.items[index].category)) {
                let param = "?item_kind_id=" + this.data.kind_id
                param += "&category_id=" + this.items[index].category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.items[index].optAdjustments = res.data.data.map(item => {
                        return {
                            value: {
                                adjustments_id: item.id,
                                adjustments_name: item.name,
                                adjustment: item.adjustment,
                                adjustment_percentage: item.adjustment_percentage,
                            },
                            text: item.name
                        }
                    })
                    this.isSubmitting = false
                })
            }
        },

        onChangeAdjCategory() {
            this.addAdj.name = null
            this.addAdj.optAdjustments = []
            if (!this.$helper.isBlank(this.addAdj.category)) {
                let param = "?item_kind_id=" + this.data.kind_id
                param += "&category_id=" + this.addAdj.category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.addAdj.optAdjustments = res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    })
                    this.isSubmitting = false
                })
            }
        },

        prepareAdjImage(item) {
            this.activeAdjustmentRow = item
            this.mediaPreview = {}
            this.mediaList = []
            this.activeAdjustment = item.adjustmentSelect
            this.isSubmitting = true
            let param = "?inventory_id=" + this.data.id
            param += "&adjustment_id=" + this.activeAdjustment.adjustments_id
            this.$axios.get("adjustment-damaged-photo" + param).then(res => {
                for (let i = 0; i < res.data.data.length; i++) {
                    let fileMedia = ''
                    let fileAltText = ''
                    if (res.data.data[i].type == 'image/jpeg' || res.data.data[i].type == 'image/png') {
                        fileMedia = 'image'
                        fileAltText = 'Upload Image Preview'
                    }
                    else if (res.data.data[i].type == 'video/mp4' || res.data.data[i].type == 'video/webm' || res.data.data[i].type == 'video/ogg' || res.data.data[i].type == 'video/3gpp') {
                        fileMedia = 'video'
                        fileAltText = 'Upload Video Preview'
                    }
                    else {
                        continue
                    }
                    let filenameSplit = res.data.data[i].path.split('/')
                    filenameSplit = filenameSplit[filenameSplit.length - 1].split('.')
                    let fileExtension = filenameSplit.pop()
                    let filename = filenameSplit.join()
                    this.mediaList.push({
                        id: res.data.data[i].id,
                        media: fileMedia,
                        type: res.data.data[i].type,
                        filename: filename,
                        extension: fileExtension,
                        url: res.data.data[i].path,
                        altText: fileAltText,
                        status: 'get',
                        isActive: false,
                        file: null
                    })
                }
                this.isImageChanged = false
                this.$bvModal.show("m-image")

                setTimeout(() => {
                    this.initResumable()
                }, 1000)
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        onClickImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                this.mediaList[i].isActive = false
                if (this.mediaList[i].url == url) {
                    this.mediaList[i].isActive = true
                    this.mediaPreview = lodash.cloneDeep(this.mediaList[i])
                }
            }
        },

        onAddImage() {
            this.$refs.fileupload.click()
        },

        onUploadImage(e) {
            var files = e.target.files || e.dataTransfer.files
            if (!files.length) return
            // else if(files[0].size > this.$uploadLimit) {
            //     return
            // }
            if (this.filterMediaList.length + files.length > 10) {
                this.$helper.toastError(this, "Operasi Upload Dibatalkan! Jumlah gambar / video melebihi kapasitas maksimal 10 item per inventori.")
                return
            }
            for (let i = 0; i < files.length; i++) {
                let fileMedia = ''
                let fileAltText = ''
                if (files[i].type == 'image/jpeg' || files[i].type == 'image/png') {
                    fileMedia = 'image'
                    fileAltText = 'Upload Image Preview'
                }
                else if (files[i].type == 'video/mp4' || files[i].type == 'video/webm' || files[i].type == 'video/ogg') {
                    fileMedia = 'video'
                    fileAltText = 'Upload Video Preview'
                }
                else {
                    this.$helper.toastError(this, "Upload Item Gagal! Jenis file " + files[i].name + " tidak dikenali oleh sistem.")
                    continue
                }
                let filenameSplit = files[i].name.split('.')
                let fileExtension = filenameSplit.pop()
                let filename = filenameSplit.join()
                let fileResult = {
                    id: null,
                    media: fileMedia,
                    type: files[i].type,
                    filename: filename,
                    extension: fileExtension,
                    url: URL.createObjectURL(files[i]),
                    altText: fileAltText,
                    status: 'upload',
                    isActive: false,
                    file: files[i]
                }
                this.mediaList.push(fileResult)
                // for(let i = 0; i < this.mediaList.length; i++){
                //     this.mediaList[i].isActive = false
                // }
                // this.mediaPreview = lodash.cloneDeep(fileResult)
                this.isImageChanged = true
                this.$helper.toastSuccess(this, "Upload " + files[i].name + " berhasil!")
            }
            this.$refs.fileupload.value = null
        },

        onOpenImage(url) {
            window.open(url, '_blank')
        },

        onDeleteImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                if (this.mediaList[i].url == url) {
                    if (this.mediaList[i].status == 'get') {
                        this.mediaList[i].status = 'delete'

                        let payload = new FormData()

                        payload.append("inventory_id", this.data.id)
                        payload.append("id_photo", this.mediaList[i].id)

                        this.$axios.post("adjustment-damaged-photo/delete", payload).then(_ => {
                            this.$helper.toastSuccess(this, "Hapus Gambar Berhasil!")
                            // this.$bvModal.hide("m-image")
                            if (this.isChangePhotoAdjustment) {
                                this.isChangeAdjustment = true
                            }

                            this.getItems()

                        })
                            .catch(error => this.$helper.parseError(this, error))
                    }
                    else {
                        this.mediaList.splice(i, 1)
                    }
                    this.isImageChanged = true
                    break
                }
            }
            this.mediaPreview = {}
        },

        // onSaveImage(id) {
        onSaveImage() {

            // if(this.filterMediaList.length < 1 && this.filterMediaList.length != 0){
            //     this.$helper.toastError(this, "Operasi Save Dibatalkan! Jumlah gambar / video kurang dari batas minimal 1 item per inventori.")
            //     return
            // }

            if (this.filterMediaList.length > 10) {
                this.$helper.toastError(this, "Operasi Save Dibatalkan! Jumlah gambar / video melebihi kapasitas maksimal 10 item per inventori.")
                return
            }

            this.isSubmitting = true

            let payload = new FormData()

            let uploadData = this.mediaList.filter(item => item.status == 'upload')
            let deleteData = this.mediaList.filter(item => item.status == 'delete')

            let totalSize = 0

            for (let i = 0; i < this.fileUploadResumable.length; i++) {
                totalSize += this.fileUploadResumable[i].file.size
                if (totalSize > 419430400) {
                    this.$helper.toastError(this, "Operasi Save Dibatalkan! Total ukuran gambar / video melebihi kapasitas maksimal 400MB untuk sekali upload.")
                    return
                }
                payload.append("url[]", this.fileUploadResumable[i].url)
                payload.append("fileName[]", this.fileUploadResumable[i].fileNameUrl)
            }

            for (let i = 0; i < deleteData.length; i++) {
                payload.append("deletes[]", deleteData[i].id)
            }

            payload.append("inventory_id", this.data.id)
            payload.append("adjustment_id", this.activeAdjustment.adjustments_id)

            this.$axios.post("adjustment-damaged-photo/update", payload).then(_ => {

                this.$helper.toastSuccess(this, "Update Gambar Berhasil!")
                this.$bvModal.hide("m-image")
                if (this.isChangePhotoAdjustment) {
                    this.isChangeAdjustment = true
                }

            })
                .catch(error => {
                    this.$helper.toastError(this, "Operasi Save Gagal! mohon dicoba kembali.")
                    this.$bvModal.hide("m-image")
                    this.initResumable()
                })
                .finally(() => {
                    this.isSubmitting = false
                    this.finalizeBroken = false
                })

        },

        onCloseModalImage(e) {
            // if (this.isImageChanged) {
            //     let isConfirmed = confirm("Apakah anda yakin ingin menutup menu Gambar Kerusakan? Perubahan yang belum disimpan akan hilang.")
            //     if (!isConfirmed) e.preventDefault()
            // }
        },

        // finds the file in the local files array
        findFile(file) {
            return this.fileUploadResumable.find(item => item.uniqueIdentifier === file.uniqueIdentifier && item.status !== 'canceled') || {}
        },
        // cancel an individual file
        cancelFile(file) {
            this.findFile(file).status = 'canceled'
            file.cancel()
        },
        initResumable() {
            // init resumablejs on mount
            this.resumable = new Resumable({
                target: this.$BASE_UPLOAD_PATH,
                fileType: ['mp4', 'mov', 'png', 'jpg', 'jpeg'],
                chunkSize: 1 * 1024 * 1024, // default is 1*1024*1024, this should be less than your maximum limit in php.ini
                headers: {
                    'Accept': 'application/json'
                },
                query: {
                    feature: "adjdmgpht",
                },
                testChunks: false,
                throttleProgressCallbacks: 1,
                chunkRetryInterval: 5000,
            });

            // Resumable.js isn't supported, fall back on a different method
            if (!this.resumable.support) return alert('Your browser doesn\'t support chunked uploads. Get a better browser.');

            this.resumable.assignBrowse(document.getElementById('uploadFile'));
            this.resumable.assignDrop(document.getElementById('uploadFile'));

            let that = this

            // set up event listeners to feed into vues reactivity
            this.resumable.on('fileAdded', (file, event) => {
                file.hasUploaded = false
                this.isUpload = true

                that.fileUploadResumable.push({
                    file: file,
                    fileName: file.fileName,
                    uniqueIdentifier: file.uniqueIdentifier || "",
                    status: 'uploading',
                    progress: 0,
                    url: "",
                    fileNameUrl: ""
                })

                this.resumable.upload()

                this.uploadKey += 1
            })

            this.resumable.on('complete', () => {
                this.finalizeBroken = true
                this.onSaveImage()
                this.isUpload = false
                that.fileUploadResumable = []
                this.getItems()
            })

            this.resumable.on('fileSuccess', (file, event) => {
                let response = JSON.parse(event)

                this.findFile(file).status = 'success'
                this.findFile(file).url = response.data.path || ""
                this.findFile(file).fileNameUrl = response.data.filename || ""

                this.uploadKey += 1
            })
            this.resumable.on('fileError', (file) => {
                this.findFile(file).status = 'error'
                this.uploadKey += 1
            })
            this.resumable.on('fileRetry', (file) => {
                this.findFile(file).status = 'retry'
                this.uploadKey += 1
            })
            this.resumable.on('fileProgress', (file) => {

                const fileUpload = this.findFile(file)

                if (fileUpload.status !== 'canceled') {
                    fileUpload.status = 'uploading'
                    fileUpload.progress = Math.floor(file.progress() * 100)
                }

                this.uploadKey += 1

            })
        },

        onRefreshImage() {
            this.prepareAdjImage(this.activeAdjustmentRow)
        },

    },
    computed: {
        filterMediaList() {
            return this.mediaList.filter(item => item.status != 'delete')
        }
    },
    created() {
        this.init()
    }
}
</script>

<style scoped>
/deep/ .adjust-column-min {
    min-width: 200px;
}

.media-container {
    height: 0;
    padding-top: 56.25%;
    position: relative;
}

.media-preview {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    left: 50%;
    transform: translateX(-50%);
}

:not(:root):-webkit-full-screen {
    object-fit: contain !important;
}

.media-scroll {
    margin-top: 10px;
    height: 70px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    background-color: #dee2e6;
    white-space: nowrap;
}

.media-scroll-content {
    display: inline-block !important;
    height: 100%;
    width: 20%;
}

.media-scroll-preview.active {
    border: 5px solid #65c2e4;
}

.media-scroll-preview:hover {
    opacity: 0.5;
}

.media-scroll-preview {
    height: 100%;
    width: 100%;
    border: 5px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    cursor: pointer;
}

.border-responsive {
    margin-top: 10px;
    border-top: 1px solid #c8ced3;
}

.media-disclaimer {
    text-align: justify;
    text-justify: inter-word;
}

@media only screen and (min-width: 576px) {
    .media-scroll {
        height: 100px;
    }
}

@media only screen and (min-width: 992px) {
    .border-responsive {
        margin-top: 0px;
        border-top: none;
        border-left: 1px solid #c8ced3;
    }
}

@media only screen and (min-width: 1200px) {
    .media-scroll {
        height: 150px;
    }
}
</style>
